import {Feature} from "geojson";

export enum LayerVisibility {
    visible = 'visible',
    none = 'none'
}

export interface IFeatureResponse<T extends IFeature> extends IFeatureCollection<T> {
    features: T[]
}

export interface IFeatureResponse_formatted<T extends IFeature> extends IFeatureCollection<T>   {
    features: T[]
}

export interface IFeatureCollection <T extends IFeature> {
    type: string | "FeatureCollection";
    name: string;
    crs?: ICRS
    features: T[]
}

export interface ICRS {
    type: string;
    properties:
        {
            name: string;
        }
}

export interface IFeature extends Feature {
    properties: IFeatureProperties
    [key: string]: any
}

//     name: '.Unknown',
//     membertype: '.Unknown',
//     websiteurl: '.Unknown',
//     notes: '.none',
//     instruc: '.none'

export interface IFeatureNewEntityProperties {
    name: string;
    membertype: string|number;
    websiteurl: string;
    notes: string;
    instruc: string;
}

export interface IFeatureProperties {
    name: string;
    membertype: string|number;
    websiteurl: string;
    notes: string;
    instruc: string;
    // optional
    datelastchanged?: string;
    description?: string;
    fullUid?: string;
    geoType?: string;
    layername?: string;
    title?: string;
    type?: string;
    [x: string]: string|number|boolean|undefined
}

export interface IFeatureNode {
    fid2?: string;
    geoType: string;
    type: string;
    fullUid: string;
    theGeom?: string;
}

export interface IFeatureViewNode {
    stAsgeojson: string;
    geoType?: string;
    type: string;
    fullUid: string;
    layername?: string;
    name: string;
    membertype?: number;
    websiteurl?: string;
    notes?: string;
    instruc?: string;
    datelastchanged?: string | Date;
    description?: string;
    document?: string;
}

export type IFeatureViewNodeParsed = (IFeatureViewNode & {feature: Feature})


/** custom types for CONO **/

export interface IFeature_Collection_CONO {
    type: string
    features: IFeature_CONO
}

export interface IFeature_CONO extends IFeature {
    properties : IFeatureProperties;
    geometry: any;
}

export interface IFeature_CONO_Point extends IFeature {
    properties : IFeatureProperties;
    geometry: any;
}

export interface IFeature_CONO_Polygon extends IFeature {
    properties : IFeatureProperties;
    geometry: any;
}

export interface IAuthenticationResponse {
    data?: {
        authenticate: {
            jwtToken: string;
            clientMutationId: string;
        }
    }
}

export interface ILayerUpdateResponse {
    data?: {
        updateLayerByType: {
            layer: {
                layername: string;
                type: string;
            }
        }
    }
}

export interface IEntityInfoResponse {
    data: {
        allEntities: {
            nodes: Array<IEntityNode & {
                    entitycontactsByFullUid: {
                        nodes: Array<{objectid: string|number, contactByPocid: IContactNode}>
                    },
                }>
        }
    }
}

export interface IEntityGeomResponse {
    data: {
        searchGeomEntities: {
            nodes: Array<IEntityNode>
        }
    }
}

export type IEntityWithContactsNodeResult = IEntityNode & {
    entitycontactsByFullUid: {
        nodes:  Array<{
            contactByPocid: IContactNode
        }>
    }
}

// searchGeomEntitiesByLayer
export interface IEntityGeomLayerResponse {
    data: {
        searchGeomEntitiesByLayer: {
            nodes: Array<IEntityNode>
        }
    }
}

export interface IEntityContactSearchResults {
    searchEntitiesByLayer: {
        nodes: Array<IEntityWithContactsNodeResult>;
    };
    searchContactsByLayer: {
        nodes: Array<{
            entitycontactsByFullUid: {
                nodes: Array<{
                    entityByFullUid: IEntityWithContactsNodeResult,
                }>
            }
        }>
    }
}

export interface IEntityContactSearchResultsById {
    searchEntitiesByLayerId: {
        nodes: Array<IEntityWithContactsNodeResult>;
    };
    searchContactsByLayerId: {
        nodes: Array<{
            entitycontactsByFullUid: {
                nodes: Array<{
                    entityByFullUid: IEntityWithContactsNodeResult,
                }>
            }
        }>
    }
}

export interface IContactResponse {
    data: {
        allContacts: {
            nodes: Array<IContactNode>
        }
    }
}

export interface IFeatureInfoResponse {
    data: {
        allEntitiesviewAdmins: {
            nodes: Array<IFeatureViewNode>
        },
        allEntitiesviews: {
            nodes: Array<IFeatureViewNode>
        }
    }
}

export interface IEntityProperties {
    fullUid: string;
    name: string;
    layername?: string;
    type?: string;
    membertype?: string;
    geoType?: string;
    websiteurl?: string;
    notes?: string;
    instruc?: string
    datelastchanged?: string;
    description?: string;
}

export type IEntityNode = IEntityProperties & {
    layerByLayerid: {
        layername: string;
        type: string;
    },
    entitycontactsByFullUid?: {
        nodes: Array<{
            contactByPocid: IContactNode
        }>
    }
    [key: string]: any;
}

export type IEntitySearchResultNode = IEntityProperties & {
    layerByLayerid?: {
        type: string;
        layername: string;
    }
    properties?: {
        [key: string]: string | undefined;
    }
}

export interface IContactNode {
    pocid?: number;
    name: string;
    land: string;
    cell: string;
    email: string;
    pubconinfo?: string;
    instruc?: string;
    datelastchanged?: string | Date;
    entitycontactId?: string | number;
}

export interface IGeometryNode {
    objectid?: number;
    fid2?: string;
    geoType: string;
    type: string;
    fullUid: string;
    theGeom?: any;
}


export interface IEntityContactNode {
    pocid: number;
    fullUid: string;
    contactByPocid?: IContactNode;
    objectid: number;
}

/** **/